/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { TitleLockup } from '@vds/type-lockups';
import { Row } from '../../../common/Grid';
import Notification from '../../../common/Notification/redesign/index';

import {
  isMobile,
  isTablet,
  getFlowType,
  getSession,
  setSession,
  viewport,
  checkIsMidnight,
  isWHWPhase2Flag,
  isWHWP2,
  getWHWSpoCookie,
  removeSessionItem,
  isExpressCheckout,
} from '../../../common/Helpers/index';
import WhwServices from './Components/FunctionalRedesign/whwServices';
import HomeProtectModal from './Components/HomePhoneModal/index';
import { getProductRefData } from '../../../../utils/plansReference';
import { store } from '../../../../configureStore';
import { eventDispatcher, updateEventInfo } from '../../../common/Tagging/index';
import { logMetrics, ACCESSORIES, USER_INFO, ADDTOCART_BUTTON_CLICK, REMOVE_BUTTON_CLICK } from '../../../../services/metricsService';

import { getDepletionType } from '../../../common/CommonUtils';
import VoiceService from './Components/FunctionalRedesign/voiceServices';
import { getAddonsRefData, getWhwRefData, prepareTilesDataServiceClone as prepareAddonsData } from './Components/FunctionalRedesign/addonsCommon';
import { Margin } from '../../../common/styles';

export default class AddonProducts extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isMobile = isMobile();
    this.isTablet = isTablet();
    this.flowType = getFlowType();
    this.cBand = false;
    this.state = {
      buttonChangeState: '',
      showAddressModal: false,
      homePhoneID: '',
      homeProdId: '',
      homePhonePrice: '',
      skipStatus: false,
      displayName: '',
      depletionType: '',
      notificationCalled: false,
      hideNotificationCalled: false,
      // disableBtn: { homeDeviceProtect: false, homeDeviceAdvisor: false },
      buttonSelectState: '',
    };
    this.prepareTilesDataServiceClone = prepareAddonsData;
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (prevState.skipStatus !== this.state.skipStatus) {
      this.props.getskipStatus(this.state.skipStatus);
    }
    if (prevState.value !== this.state.showAddressModal) {
      this.setState((prevStateCallB) => ({ showAddressModal: prevStateCallB.showAddressModal }));
    }
    if (getSession('addonBack') === 'true') {
      // this.props.setAddons([]);
      setSession('addonBack', false);
    }
    if (this.props?.cartDetails?.dueMonthlyList?.length > prevProps?.cartDetails?.dueMonthlyList?.length && !isMobile()) {
      window.scrollTo(0, this.state.scrollPosition);
    }
  }

  openHomePhoneModal = (data, homePhoneID, homeProdId, homePhonePrice, displayName, depletionType) => {
    this.setState({
      showAddressModal: true,
      homePhoneID,
      homeProdId,
      homePhonePrice,
      displayName,
      depletionType,
    });
  };

  closeModal = () => {
    this.setState({ showAddressModal: false });
  };

  changeSkip = (val) => {
    this.setState({ skipStatus: val });
  };

  showNotification = (displayName, count) => {
    let verbiage = '';
    this.setState({ notificationCalled: true });
    this.setState({ hideNotificationCalled: false });
    if (!this.isMobile) {
      verbiage = `${(count && count !== 0) || ''} ${displayName !== undefined ? displayName : ''} is added to your cart.`;
      this.props.showAddonNotification(verbiage);
    } else if (this.isMobile) {
      this.props.showAddonNotification('mdot');
    }
  };

  hideNotification = () => {
    this.props.showAddonNotification('');
    this.props.setSelectedProduct('');
    this.setState({ notificationCalled: false });
  };

  setSelectedProduct = (prodID) => {
    this.props.setSelectedProduct(prodID);
  };

  addToCart = (notifyMessage, skuDetails, type, displayName, selectedWHW) => {
    store.dispatch({ type: 'LOADING_DONE', response: false });
    const oddOnList = this.props && this.props && this.props.addonObj ? this.props.addonObj : [];
    if (this.state.buttonChangeState === 'changed' || this.props.byPassingForTesting) {
      this.setState({ buttonChangeState: '' });
    }
    this.setState({ buttonChangeState: 'changed' });
    if (type === 'streamingDevice') {
      const prodId = skuDetails && skuDetails.sorId ? skuDetails.sorId : skuDetails.productId;
      const qty = '1';
      const depletionType = getDepletionType(this.props.cartDetails?.dueTodayList);
      const data = {
        addAccessories: {
          prodId,
          qty,
        },
        depletionType,
      };
      if (notifyMessage) {
        data.notifyMessage = notifyMessage;
      }
      this.props.postAddToCart(data, this.props.type, oddOnList, 'addToCart');
      eventDispatcher('addToCart', data);
      updateEventInfo('scAdd');
      this.setState({ buttonSelectState: 'add' });
      this.setSelectedProduct(prodId);
    } else if (type === 'streamingService') {
      const prodId = skuDetails && skuDetails.sorId ? skuDetails.sorId : skuDetails.productId;
      const { pricePlanId } = this.props;
      const price = skuDetails && skuDetails.priceText;
      const name = skuDetails && skuDetails.displayName;
      const data = {
        addYtTv: {
          prodId,
          pricePlanId,
          price,
          name,
        },
      };
      if (notifyMessage) {
        data.notifyMessage = notifyMessage;
      }
      this.props.postAddToCart(data, type, oddOnList, 'addToCart');
      eventDispatcher('addToCart', data);
      updateEventInfo('scAdd');
      this.setSelectedProduct(prodId);
      if (this.props) {
        this.props.getskipStatus(true);
      }
      // else if (this.props?.getskipStatus) {
      //   this.props.getskipStatus(true);
      // }
    } else if (type === 'vzProtectHome') {
      const prodId = skuDetails && skuDetails.sorId ? skuDetails.sorId : skuDetails.productId;
      const qty = '1';

      const data = {
        addVZProtect: {
          prodId,
          qty,
        },
      };
      if (notifyMessage) {
        data.notifyMessage = notifyMessage;
      }
      this.props.postAddToCart(data, type, oddOnList, 'addToCart');
      eventDispatcher('addToCart', data);
      updateEventInfo('scAdd');
      this.setSelectedProduct(prodId);
    } else if (type === 'whwServices') {
      const WHWSession = viewport() === 'mfapp' ? getWHWSpoCookie('whwSpoDetails') : getSession('whwSpoDetails');
      const WHWSessionData = WHWSession && JSON.parse(WHWSession)?.spoDetails;
      const redemptionShipmentPending = JSON.parse(WHWSession)?.pendingShipment;
      const extAddedOnProfile = WHWSession && JSON.parse(WHWSession)?.extenderOnProfile;
      const getQTY = extAddedOnProfile === '0' ? WHWSessionData?.find((obj) => obj?.spoid === selectedWHW?.sorId)?.min : '1';
      const SkuDetail = WHWSession && JSON.parse(WHWSession)?.extSku;
      const redemptionSPO = selectedWHW?.sorId;
      const whwProdId = skuDetails[1]?.skuDetails?.sorId;
      const whwProdName = displayName;
      const isDownGradeRedeem =
        isWHWP2() &&
        ((extAddedOnProfile > '1' && selectedWHW?.categoryType?.includes('WHWBASIC')) ||
          (extAddedOnProfile === '3' && selectedWHW?.categoryType?.includes('WHWPLUS')));
      const visionPending = isWHWP2() && WHWSession && JSON.parse(WHWSession)?.visionPendingOrder;
      const mon = WHWSession && JSON.parse(WHWSession)?.mon;
      const visionPendingOrder =
        isDownGradeRedeem && visionPending && mon && visionPending !== '' && visionPending !== null && mon !== '' && mon !== null;
      if (isWHWP2() && redemptionShipmentPending) {
        store.dispatch({ type: 'OPEN_MODAL' });
      }
      if (isWHWP2() && visionPendingOrder) {
        store.dispatch({ type: 'VISION_PENDING_STATUS', value: true });
      }

      let whwQty = '1';
      let whwData = {
        addWHWPlan: {
          whwProdId,
          whwQty,
        },
      };
      const isRedeemButton =
        isWHWP2() &&
        (extAddedOnProfile === '2' || extAddedOnProfile === '0') &&
        WHWSessionData.find((obj) => obj.current === true).spoid === redemptionSPO;
      const isUpgradeFlow = extAddedOnProfile && extAddedOnProfile < '2' && selectedWHW?.categoryType?.includes('WHWPLUS');
      if (isWHWP2() && extAddedOnProfile) {
        const redemptionUpgradeQty = extAddedOnProfile === '1' ? '1' : WHWSessionData?.find((obj) => obj?.spoid === selectedWHW?.sorId)?.min || '';
        const maxLimitBasic = WHWSessionData?.find((obj) => !obj?.spoDesc.toLowerCase().includes('plus'))?.maxLimit;
        const maxLimitPlus = WHWSessionData?.find((obj) => obj?.spoDesc.toLowerCase().includes('plus'))?.min;
        const redemptionDownGradeQty =
          isDownGradeRedeem && extAddedOnProfile === '3' && selectedWHW?.categoryType?.includes('WHWPLUS')
            ? extAddedOnProfile - maxLimitPlus
            : extAddedOnProfile - maxLimitBasic;
        whwQty = isDownGradeRedeem ? '1' : redemptionUpgradeQty;
        if (isDownGradeRedeem) {
          setSession(
            'downgradeDetails',
            JSON.stringify({ Downgrade: isDownGradeRedeem, returnqty: redemptionDownGradeQty, selectedSPO: selectedWHW?.sorId }),
          );
          store.dispatch({ type: 'DOWNGRADE_REDEMPTION', value: true });
        } else if (getSession('downgradeDetails') && !isDownGradeRedeem) {
          store.dispatch({ type: 'DOWNGRADE_REDEMPTION', value: false });
          removeSessionItem('downgradeDetails');
        }
        whwData = {
          addWHWPlan: {
            whwProdId,
            whwQty,
            isRedeemButton,
            isDownGradeRedeem,
            isUpgradeFlow,
          },
        };
      }
      const extenderData = {
        spoId: redemptionSPO,
        qty: getQTY,
        value: 'WHWExtender',
        routerSku: SkuDetail,
      };
      if (notifyMessage) {
        whwData.notifyMessage = notifyMessage;
      }
      if (whwProdName) {
        whwData.prodName = whwProdName;
      }
      if (!redemptionShipmentPending && !visionPendingOrder) {
        if (!isWHWP2() || (isWHWP2() && !isRedeemButton)) {
          this.props.postAddToCart(whwData, type, oddOnList, 'addToCart');
        } else {
          this.props.postAddToCart(extenderData, extenderData.value);
        }
      }
      eventDispatcher('addToCart', whwData);
      updateEventInfo('scAdd');
      this.setSelectedProduct(whwProdId);
    } else if (type === 'homePhoneService' && this.cBand) {
      let zipCode;
      let city;
      let fipsCode;
      let addressLine1;
      let state;
      const LQResponseData = getSession('LQResponse');
      const ConditionLQResp =
        (LQResponseData && LQResponseData !== undefined && LQResponseData.output) ||
        (store.getState()?.cartDetails?.cartDetailsJson?.shippingDetails &&
          store.getState()?.cartDetails?.cartDetailsJson?.shippingDetails[0]?.address);
      if ((ConditionLQResp && ConditionLQResp !== undefined) || this.props.byPassingForTesting) {
        zipCode = ConditionLQResp?.zipCode ? ConditionLQResp.zipCode : '';
        city = ConditionLQResp?.city ? ConditionLQResp.city : '';
        fipsCode = ConditionLQResp?.fipsCode ? ConditionLQResp.fipsCode : '';
        addressLine1 = ConditionLQResp?.addressLine1 ? ConditionLQResp.addressLine1 : '';
        state = ConditionLQResp?.state ? ConditionLQResp.state : '';
      }
      const depletionType = getDepletionType(this.props.cartDetails?.dueTodayList);
      const data = {
        prodId: this.props.homePhoneID,
        qty: '1',
        planId: this.props.homeProdId,
        zipCode,
        city,
        fipsCode,
        addressLine1,
        state,
        depletionType,
      };
      this.props.postAddToCart(data, type, oddOnList, 'addToCart');
    }
    logMetrics(ACCESSORIES, USER_INFO, ADDTOCART_BUTTON_CLICK);
  };

  buttonChangeClear = (e) => {
    if (e.charCode === 0) {
      if (this.state.buttonChangeState === 'changed') {
        this.setState({ buttonChangeState: '' });
      }
    }
  };

  removeCart = (skuDetails, displayName, type) => {
    const oddOnList = this.props && this.props.addonObj ? this.props.addonObj : [];
    if (this.state.buttonChangeState === 'changed' || this.props.byPassingForTesting) {
      this.setState({ buttonChangeState: '' });
    }
    this.setState({ buttonChangeState: 'changed' });
    if (type === 'streamingService') {
      const prodId = skuDetails && skuDetails.sorId ? skuDetails.sorId : skuDetails.productId;
      const { pricePlanId } = this.props;
      const price = skuDetails && skuDetails.priceText;
      const name = skuDetails && skuDetails.displayName;
      const depletionType = getDepletionType(this.props.cartDetails?.dueTodayList);
      const data = {
        removeYtTv: {
          prodId,
          pricePlanId,
          price,
          name,
        },
        depletionType,
      };
      this.props.postAddToCart(data, type, oddOnList, 'removeFromCart');
      eventDispatcher('removeFromCart', data);
      if (this.props) {
        this.props.getskipStatus(false);
      }
      // else if (this.props?.getskipStatus) {
      //   this.props.getskipStatus(false);
      // }
      this.setState({ buttonSelectState: 'remove' });
    } else if (type === 'vzProtectHome') {
      const prodId = skuDetails && skuDetails.sorId ? skuDetails.sorId : skuDetails.productId;
      const qty = '1';
      const numOfLines = this.props.cartDetails && this.props.cartDetails.orderDetailsView && this.props.cartDetails.orderDetailsView.numOfLines;
      const data = {
        removeVZProtect: {
          prodId,
          qty,
          numOfLines,
        },
      };
      this.props.postAddToCart(data, type, oddOnList, 'removeFromCart');
      eventDispatcher('removeFromCart', data);
    } else if (type === 'whwServices') {
      const whwRemoveProdId = skuDetails && skuDetails.sorId ? skuDetails.sorId : skuDetails.productId;
      const whwRemoveQty = '1';
      const whwRemoveNumOfLines =
        this.props.cartDetails && this.props.cartDetails.orderDetailsView && this.props.cartDetails.orderDetailsView.numOfLines;
      const whwRemoveData = {
        removeWHWPlan: {
          whwRemoveProdId,
          whwRemoveQty,
          whwRemoveNumOfLines,
        },
      };
      this.props.postAddToCart(whwRemoveData, type, oddOnList, 'removeFromCart');
      eventDispatcher('removeFromCart', whwRemoveData);
    } else if (type === 'homePhoneService' && !this.cBand) {
      const npanxxVal = this.props.npanxx;
      const depletionType = getDepletionType(this.props.cartDetails?.dueTodayList);
      const data = {
        npanxx: npanxxVal,
        depletionType,
      };
      this.props.postAddToCart(data, 'removeHomePhone', oddOnList, 'removeFromCart');
      eventDispatcher('removeFromCart', data);
      store.dispatch({ type: 'IS_E911_CALL', value: false });
    } else if (type === 'homePhoneService' && this.cBand) {
      const depletionType = getDepletionType(this.props.cartDetails?.dueTodayList);
      const data = {
        depletionType,
      };
      this.props.postAddToCart(data, 'removeHomePhone', oddOnList, 'removeFromCart');
      eventDispatcher('removeFromCart', data);
    }
    logMetrics(ACCESSORIES, USER_INFO, REMOVE_BUTTON_CLICK);
  };

  openModal = (homePhoneID, homeProdId, homePhonePrice, displayName) => {
    store.dispatch({ type: 'LOADING_DONE', response: false });

    this.setSelectedProduct(homePhoneID);
    this.setState({ showAddressModal: true }, () => {
      this.openHomePhoneModal(
        this.props,
        homePhoneID,
        homeProdId,
        homePhonePrice,
        displayName,
        getDepletionType(this.props.cartDetails?.dueTodayList),
      );
    });
    const obj = {
      name: '5GhomeServiceModal',
      selector: 'homeServiceId',
    };
    eventDispatcher('openView', obj);
    store.dispatch({ type: 'IS_E911_CALL', value: false });
  };

  onRemovingStreamTV = (buttonValue) => {
    this.setState({ buttonSelectState: buttonValue });
  };

  getTodayPhone = (cartDetails, homeId) => {
    let value;
    if (cartDetails && cartDetails.dueTodayList) {
      cartDetails.dueTodayList.map((item) => {
        const cartId = item.sorId ? item.sorId : item.productId;
        if (cartId === homeId) {
          value = true;
        }
        return value;
      });
    }
    return value;
  };

  getMonthlyPhone = (cartDetails, prodId) => {
    let value;
    if (cartDetails && cartDetails.dueMonthlyList) {
      cartDetails.dueMonthlyList.map((item) => {
        const cartId = item.sorId ? item.sorId : item.productId;
        if (cartId === prodId) {
          value = true;
        }
        return value;
      });
    }
    return value;
  };

  getNotification = (selectedProdID, planName, prodId, flag) => {
    if (!this.props.skipBtnCall) {
      store.dispatch({ type: 'SHOW_SKIP_BTN', response: true });
      store.dispatch({ type: 'SKIP_BTN_CALLED', response: true });
    }
    if (flag && !this.state.notificationCalled && selectedProdID && selectedProdID === prodId) {
      store.dispatch({ type: 'SHOW_SKIP_BTN', response: true });
      store.dispatch({ type: 'SKIP_BTN_CALLED', response: true });
    }
    if (!this.state.notificationCalled && selectedProdID && selectedProdID === prodId) {
      this.showNotification(planName, 0, selectedProdID);
    }
    if (this.props.showAddNotification && this.props.showAddNotification !== '' && prodId === selectedProdID && !this.state.hideNotificationCalled) {
      setTimeout(() => {
        this.hideNotification();
      }, 6000);
      this.setState({ hideNotificationCalled: true });
    }
  };

  updateModalState = (modalState) => {
    this.setState({ showAddressModal: modalState });
  };

  render() {
    const {
      title5G,
      titleLTE,
      products,
      subTitle5G,
      subTitleLTE,
      plansReferenceData,
      cartDetails,
      selectedProdID,
      addOnLoadingDone,
      valuedServicesHeader,
      valuedServicesSubHeader,
      titleWhw,
      titleRedemption,
      subTitleRedemption,
      whwDetails,
      subTitleWhw,
    } = this.props;

    const addonProducts = [];
    let whwaccessoryReferenceData = [];
    const isCBandFlow = getSession('isCBandFlow');
    if (isCBandFlow === 'Y') {
      this.cBand = true;
    }
    if (products && products.length > 0) {
      products.map((data) => {
        if (data && data.displayName != null && data.displayName !== undefined) {
          if (this.cBand) {
            addonProducts.push(data);
          } else if (data.displayName.toLowerCase() !== 'home device advisor') {
            addonProducts.push(data);
          }
        }

        return addonProducts;
      });
    }
    if (addonProducts) {
      addonProducts.map((data) => {
        let quantity;
        let prodId;
        let todayPhone;
        let monthlyPhone;
        let homeId; // let homePhone;
        const prodType = data.type;
        if (data.skuDetails) {
          homeId = data.skuDetails.sorId ? data.skuDetails.sorId : '';
          prodId = data.skuDetails.productId ? data.skuDetails.productId : '';
        }
        let planName;
        this.planInfo = getProductRefData(data.skuDetails.sorId, data.skuDetails.productId, plansReferenceData);
        const planInfo = this.planInfo && this.planInfo.length > 0 ? this.planInfo[0] : '';
        if (planInfo) {
          planName = planInfo.displayName ? planInfo.displayName : planInfo.planName;
        }
        if (prodType === 'homePhoneService') {
          todayPhone = this.getTodayPhone(cartDetails, homeId);
          monthlyPhone = this.getMonthlyPhone(cartDetails, prodId);

          // getNotification call
          if (monthlyPhone && todayPhone) {
            quantity = '1';
            this.getNotification(selectedProdID, planName, prodId, true);
          }
        } else if (prodType !== 'homePhoneService') {
          if (cartDetails && cartDetails.dueMonthlyList) {
            cartDetails.dueMonthlyList.map((item) => {
              const cartId = item.sorId ? item.sorId : item.productId;
              if (cartId === homeId) {
                quantity = '1';
                if (!this.props.skipBtnCall) {
                  store.dispatch({ type: 'SHOW_SKIP_BTN', response: true });
                  store.dispatch({ type: 'SKIP_BTN_CALLED', response: true });
                }
                if (!this.state.notificationCalled && selectedProdID && selectedProdID === cartId && addOnLoadingDone) {
                  this.setState({
                    scrollPosition: window.scrollY,
                  });
                  if (!isMobile()) {
                    window.scrollTo(0, 0);
                  }
                  this.showNotification(planName, 0, selectedProdID);
                  setTimeout(() => {
                    this.hideNotification();
                  }, 6000);
                }
              }
              return quantity;
            });
          }
        }
        if (quantity === '1') {
          this.changeSkip(true);
        } else {
          this.changeSkip(false);
        }
        return quantity;
      });
    }

    let whwTileData = {};
    if (isWHWPhase2Flag()) {
      whwTileData = this.prepareTilesDataServiceClone(whwDetails, cartDetails, selectedProdID, addOnLoadingDone, this, this.props);
      whwaccessoryReferenceData = getWhwRefData(whwDetails, this.props.plansReferenceData);
      // const dummy1 = whwDetails.find((obj) => obj.displayName === 'Whole Home Wifi');
    }

    let bauTileData = {};
    let accessoryReferenceData = {};
    let mainTile =
      this?.flowType && this?.flowType === 'LTE' ? titleLTE || 'Voice & Home Protection Services' : title5G || 'Home Protection Services';
    let subTitle =
      this?.flowType && this?.flowType === 'LTE'
        ? subTitleLTE || 'Protect all your connected devices with these services'
        : subTitle5G || 'Protect all your connected devices with these services';
    if (checkIsMidnight()) {
      bauTileData = this.prepareTilesDataServiceClone(products, cartDetails, selectedProdID, addOnLoadingDone, this, this.props);
      accessoryReferenceData = getAddonsRefData(products, this.props.plansReferenceData);
      mainTile = valuedServicesHeader;
      subTitle = valuedServicesSubHeader;
    }
    const notificationProps = {
      renderIf: false,
      title: '',
      type: '',
      subtitle: '',
      hideCloseButton: false,
    };
    if (isWHWP2()) {
      const {
        ext0Redeem0Title,
        ext0Redeem0SubTitle,
        ext0Redeem2Title,
        ext0Redeem2SubTitle,
        ext1Redeem0Title,
        ext1Redeem0SubTitle,
        ext1Redeem1Title,
        ext1Redeem1SubTitle,
        ext2Redeem0Title,
        ext2Redeem0SubTitle,
        ext3Redeem0Title,
        ext3Redeem0SubTitle,
      } = this.props;
      const SessionValueWHW = viewport() === 'mfapp' ? getWHWSpoCookie('whwSpoDetails') : getSession('whwSpoDetails');
      const parsedSession = SessionValueWHW && JSON.parse(SessionValueWHW);
      const downgradeSession = getSession('downgradeDetails') && JSON.parse(getSession('downgradeDetails'));
      if (
        !downgradeSession &&
        parsedSession?.extenderOnProfile === '0' &&
        (!this.props?.cartDetails.dueMonthlyList ||
          (this.props?.cartDetails?.dueMonthlyList &&
            !this.props?.cartDetails?.dueMonthlyList.find((obj) => obj?.itemType && obj?.itemType.toLowerCase().indexOf('whwplus') !== -1)))
      ) {
        notificationProps.renderIf = true;
        notificationProps.title = ext0Redeem0Title || '1 extender is included with your current plan.';
        notificationProps.subtitle = ext0Redeem0SubTitle || 'If you need more than 1 extender, upgrade to Whole-Home Wi-Fi Plus.';
        notificationProps.type = 'info';
        notificationProps.hideCloseButton = true;
      } else if (
        !downgradeSession &&
        parsedSession?.extenderOnProfile === '0' &&
        this.props?.cartDetails &&
        this.props?.cartDetails.dueMonthlyList &&
        this.props?.cartDetails?.dueMonthlyList.find((obj) => obj?.itemType && obj?.itemType.toLowerCase().indexOf('whwplus') !== -1)
      ) {
        notificationProps.renderIf = true;
        notificationProps.title = ext0Redeem2Title || "You're upgrading to Whole-Home Wi-Fi Plus.";
        notificationProps.subtitle =
          ext0Redeem2SubTitle ||
          '2 extenders will be shipped as part of your new plan. If you need another extender, please request it once the 2 extenders have been shipped.';
        notificationProps.type = 'info';
        notificationProps.hideCloseButton = true;
      } else if (
        !downgradeSession &&
        parsedSession?.extenderOnProfile === '1' &&
        (!this.props?.cartDetails.dueMonthlyList ||
          (this.props?.cartDetails?.dueMonthlyList &&
            !this.props?.cartDetails?.dueMonthlyList.find((obj) => obj?.itemType && obj?.itemType.toLowerCase().indexOf('whwplus') !== -1)))
      ) {
        notificationProps.renderIf = true;
        notificationProps.title = ext1Redeem0Title || 'You have redeemed 1 extender as part of your plan.';
        notificationProps.subtitle = ext1Redeem0SubTitle || 'Upgrade to Whole-Home Wi-Fi Plus and get up to 2 more extenders.';
        notificationProps.type = 'info';
        notificationProps.hideCloseButton = true;
      } else if (
        !downgradeSession &&
        parsedSession?.extenderOnProfile === '1' &&
        this.props?.cartDetails &&
        this.props?.cartDetails.dueMonthlyList &&
        this.props?.cartDetails?.dueMonthlyList.find((obj) => obj?.itemType && obj?.itemType.toLowerCase().indexOf('whwplus') !== -1)
      ) {
        notificationProps.renderIf = true;
        notificationProps.title = ext1Redeem1Title || 'You’re upgrading to Whole-Home Wi-Fi Plus.';
        notificationProps.subtitle = ext1Redeem1SubTitle || 'You can request up to 2 extenders.';
        notificationProps.type = 'info';
        notificationProps.hideCloseButton = true;
      } else if (!downgradeSession && parsedSession?.extenderOnProfile === '2') {
        notificationProps.renderIf = true;
        notificationProps.title = ext2Redeem0Title || 'You have redeemed 2 of 3 Wi-Fi extenders.';
        notificationProps.subtitle = ext2Redeem0SubTitle || 'You have 1 extender left to redeem.';
        notificationProps.type = 'info';
        notificationProps.hideCloseButton = true;
      } else if (!downgradeSession && parsedSession?.extenderOnProfile === '3') {
        notificationProps.renderIf = true;
        notificationProps.title = ext3Redeem0Title || "You've redeemed all 3 of your Wi-Fi extenders.";
        notificationProps.subtitle = ext3Redeem0SubTitle || "You've no more extenders available to redeem.";
        notificationProps.type = 'info';
        notificationProps.hideCloseButton = true;
      }
    }

    return (
      <React.Fragment>
        {whwDetails && whwDetails.length > 0 && isWHWPhase2Flag() && (
          <>
            <Margin bottom="20px" top="20px">
              <TitleLockup
                data={{
                  title: {
                    bold: !!isExpressCheckout(),
                    size: 'titleSmall',
                    children: isWHWP2() ? titleRedemption || 'Optimize your Wi-Fi coverage' : titleWhw,
                  },
                  subtitle: {
                    size: 'bodyMedium',
                    color: 'primary',
                    children: isWHWP2()
                      ? subTitleRedemption ||
                        'Whole-Home Wi-Fi is included with your current plan. You can upgrade based on the requirements of your home.'
                      : subTitleWhw,
                  },
                }}
              />
            </Margin>
            {isWHWP2() && (
              <Row className="marginBottom10">
                <Notification {...notificationProps} />
              </Row>
            )}
            <WhwServices
              refData={whwaccessoryReferenceData}
              accessory={whwDetails}
              removeAddon={this.removeCart}
              addAddon={this.addToCart}
              updateAddonQuantity={this.onRemovingStreamTV}
              whwTileData={whwTileData}
              notifyMessage={this.props.notifyMessage}
              buttonSelectState={this.state.buttonSelectState}
              parentProps={this.props}
            />
          </>
        )}
        {addonProducts.length > 0 ? (
          <>
            <Margin bottom="20px" top="20px">
              <TitleLockup
                data={{
                  title: {
                    bold: false,
                    size: 'titleSmall',
                    children: mainTile,
                  },
                  subtitle: {
                    size: 'bodyMedium',
                    color: 'primary',
                    children: subTitle,
                  },
                }}
              />
            </Margin>
            <VoiceService
              services={products}
              refData={accessoryReferenceData}
              bauTileData={bauTileData}
              removeAddon={this.removeCart}
              actionModal={this.openModal}
              addToCart={this.addToCart}
              notifyMessage={this.props.notifyMessage}
              buttonSelectState={this.state.buttonSelectState}
              parentProps={this.props}
            />
          </>
        ) : (
          <Margin top="20px" />
        )}
        {this.state.showAddressModal && (
          <HomeProtectModal
            propsList={this.props}
            homePhoneID={this.state.homePhoneID}
            homeProdId={this.state.homeProdId}
            opened={this.state.showAddressModal}
            closeModal={this.closeModal}
            onOpenedChange={this.updateModalState}
            title={this.state.displayName}
            price={parseFloat(this.state.homePhonePrice).toFixed(2)}
            e911ErrorText={this.props.e911ErrorText}
            depletionType={this.state.depletionType}
            addOnLoadingDone={addOnLoadingDone}
            skipBtnCall={this.props.skipBtnCall}
          />
        )}
      </React.Fragment>
    );
  }
}

AddonProducts.propTypes = {
  products: PropTypes.array,
  plansReferenceData: PropTypes.object,
  skipBtnCall: PropTypes.any,
};
